import { WarningOutlined } from "@ant-design/icons";
import { GraphTooltip } from "components/GraphTooltip";

export const PolicyChangeWarning: React.FC = () => (
  <GraphTooltip title="Changes to access policies do not revoke existing access. They only apply to future requests.">
    <WarningOutlined style={{ marginLeft: 8 }} />
  </GraphTooltip>
);
